module.exports = __webpack_public_path__ + "static/wingpaper_logo-0ebd6ad64360298fcd7b4c258c240b31.png";